import { useLocation } from "react-router-dom";

import qs from "qs";

const useUrlParams = () => {
  const { search } = useLocation();
  return qs.parse(search, {
    ignoreQueryPrefix: true,
  });
};

export default useUrlParams;
